$(document).ready(function() {
  var articleImg = $('.news-item-detail meta[itemprop="url"]').attr('content');
  var articleTitleText = $('.news-item-detail h1[itemprop="headline"]').text();
  var articleTitle = $('.news-item-detail h1[itemprop="headline"]').html()
  $('.news-item-detail>.text').prepend('<div class="text-header"><div class="left"><img src="'+articleImg+'" alt="'+articleTitleText+'"></div><div class="right"><div class="h1">'+articleTitle+'</div><p class="customPre"></p></div></div>')
  $('.customPre').append($('.news-item-detail pre'))
});